<script setup lang="ts">
const { side = 'left' } = defineProps<{
  side?: 'left' | 'right';
  error?: boolean;
}>();
</script>

<template>
  <button
    class="input-button"
    :class="[`_side-${side}`, { _error: error }]"
  >
    <span class="content">
      <slot />
    </span>
  </button>
</template>

<style scoped lang="scss">
.input-button {
  flex-shrink: 0;
  position: relative;

  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;

  transition: opacity var(--transition-fast);

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &._side-left {
    margin-left: -8px;
  }

  &._side-right {
    margin-right: -8px;
  }

  @media (hover: hover) {
    &::before {
      content: '';

      position: absolute;
      top: 0;
      bottom: 0;
      width: 110%;

      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      background: linear-gradient(to right, var(--color-gray-100) 80%, transparent);
      opacity: 0;

      transition: opacity var(--transition-fast);
    }

    &._side-left {
      &::before {
        left: 0;
      }
    }

    &._side-right {
      &::before {
        right: 0;
        transform: rotate(180deg);
      }
    }

    &:not(:disabled) {
      &:hover {
        &::before {
          opacity: 0.75;
        }
      }
    }
  }

  :deep(svg) {
    transition: all var(--transition-fast);
  }

  &._error {
    :deep(svg) {
      fill: var(--color-red-800);
    }

    @media (hover: hover) {
      &::before {
        background: linear-gradient(to right, var(--color-red-250) 80%, transparent);
      }
    }
  }
}

.content {
  position: relative;
  z-index: 1;
}
</style>
